export default "__VITE_ASSET__Bu__RWR___"